<!-- 车辆及车牌图片补录接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructureForThirdPark"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
      return {
        requestBody: {
                "parkCode": "2KKN885S",
                "connectorAccount": "changjun1",
                "parkingCode": "190708105000313444714122",
                "carCode": "粤YWDL22",
                "finalCarCode": "粤YWDL22",
                "finalReliability": 97.11,
                "reliability": 97.11,
                "recordType": 0,
                "cameraType": 0,
                "cameraCode": "0",
                "cardImage": "iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAIAAADYYG7QAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAD6SURBVFhH7ZZRDsIwDEN3Wu5/g4FUEUVNmZ0mEkN4X0Ba9fXFaznOmz3HzXhOAaGOyJAMIQOorgz9haHH+3nt1n9Gm6fqiQzZ2hGokQwDLTlss6M6vrbYwkBetF/eQyz5qA6FQc1AexB+Vj9QsXEYKGYI/lLxhIFSGaqgjLnNQDH1WcR9oKlx33ztlyd1McsmkjXkfUxduChl+4UzNC22jEiXGzbU8XL4ZGjDR5zCtmx5Ufgg241WxCoBmbypa5WXfxMo5ub6TwGvjQVi1mPGQDIWiD/3iqdAAghurmWAgJBGGZIhZADVlSEZQgZQXRmSIWQA1ZWhnzP0BG0XxAI+PzZQAAAAAElFTkSuQmCC",
                "carImage": "iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAIAAADYYG7QAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAD6SURBVFhH7ZZRDsIwDEN3Wu5/g4FUEUVNmZ0mEkN4X0Ba9fXFaznOmz3HzXhOAaGOyJAMIQOorgz9haHH+3nt1n9Gm6fqiQzZ2hGokQwDLTlss6M6vrbYwkBetF/eQyz5qA6FQc1AexB+Vj9QsXEYKGYI/lLxhIFSGaqgjLnNQDH1WcR9oKlx33ztlyd1McsmkjXkfUxduChl+4UzNC22jEiXGzbU8XL4ZGjDR5zCtmx5Ufgg241WxCoBmbypa5WXfxMo5ub6TwGvjQVi1mPGQDIWiD/3iqdAAghurmWAgJBGGZIhZADVlSEZQgZQXRmSIWQA1ZWhnzP0BG0XxAI+PzZQAAAAAElFTkSuQmCC"

            },
        responseCode: {
          "data": {
          }, "message": "业务成功", "resultCode": 0, "status": 1
        },
        infoData: {
          explain: "第三方接入系统主动推送车辆图片信息到智慧停车开放平台",
          sdkcondition: "cmd='upThirdParkCarPic'",
          t_url: this.commonUrls.test+"upThirdParkCarPic",
          p_url: this.commonUrls.prod+"upThirdParkCarPic",
          precondition: "无",
          fitSystem: "VEMS传统停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' },
              { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
              { info1: 'connectorAccount', info2: '是', info3: 'String', info4: '车场连接端账号' },
              { info1: 'parkingCode', info2: '是', info3: 'String', info4: '停车记录流水号' },
              { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌号码(摄影头识别的)' },
              { info1: 'finalCarCode', info2: '是', info3: 'String', info4: '最终识别车牌，如果无变化则传原最终识别车牌' },
              { info1: 'finalReliability', info2: '是', info3: 'Decimal', info4: '综合车牌最终识别可信度	保留两位小数（如：90.1）' },
              { info1: 'reliability', info2: '是', info3: 'Decimal', info4: '车牌识别可信度	保留两位小数（如：90.1）' },
              { info1: 'recordType', info2: '是', info3: 'Integer', info4: '关联的记录类型 0正常出入车 1异常开闸 2驾驶位抓拍' },
              { info1: 'cameraType', info2: '是', info3: 'Integer', info4: '记录类型	0进场 1离场' },
              { info1: 'cameraCode', info2: '是', info3: 'String', info4: '摄像头编号'},
              { info1: 'cardImage', info2: '是', info3: 'String', info4: 'base64车牌照片，车入场后，对抓拍的大图中的车牌进行裁剪部分，recordType=0或recordType=1时不为空；当recordType=2时为空' },
              { info1: 'carImage', info2: '是', info3: 'String', info4: 'base64车的照片，车入场是抓拍的大图' },
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' },
              { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [

            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
            td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/thirdParkForAke/upward/upThirdParkCarPic.vue